<div class="erp-login-shell">

  <!-- Left branding panel -->
  <div class="erp-login-brand d-none d-md-flex">
    <div class="erp-login-brand-inner">
      <img
        src="assets/media/logos/mavles/logo-mavles-full.png"
        alt="Mavles"
        class="erp-login-logo"
      />
      <h2 class="erp-login-tagline">Enterprise Resource Planning</h2>
      <p class="erp-login-sub">
        Streamline operations, orders, accounts &amp; HR in one place.
      </p>
      <ul class="erp-login-features">
        <li><i class="bi bi-check2-circle me-2"></i>Order &amp; Purchase Management</li>
        <li><i class="bi bi-check2-circle me-2"></i>Accounts &amp; Payments</li>
        <li><i class="bi bi-check2-circle me-2"></i>HRM &amp; Work Reports</li>
        <li><i class="bi bi-check2-circle me-2"></i>Real-time Dashboards</li>
      </ul>
    </div>
  </div>

  <!-- Right form panel -->
  <div class="erp-login-form-panel">
    <div class="erp-login-form-wrap">

      <!-- Mobile logo -->
      <div class="text-center mb-4 d-md-none">
        <img
          src="assets/media/logos/mavles/logo-mavles-full.png"
          alt="Mavles"
          style="height: 50px"
        />
      </div>

      <!-- Heading -->
      <div class="erp-login-heading mb-4">
        <h4>Welcome back</h4>
        <p>Sign in to your Mavles account</p>
      </div>

      <!-- Form -->
      <form [formGroup]="loginForm" (ngSubmit)="onLogin()" novalidate>

        <!-- Email -->
        <div class="mb-3">
          <label class="form-label">Email address</label>
          <div class="erp-input-group">
            <i class="bi bi-envelope"></i>
            <input
              type="email"
              class="form-control"
              formControlName="email"
              placeholder="you@company.com"
              autocomplete="email"
            />
          </div>
        </div>

        <!-- Password -->
        <div class="mb-4">
          <label class="form-label">Password</label>
          <div class="erp-input-group">
            <i class="bi bi-lock"></i>
            <input
              type="password"
              class="form-control"
              formControlName="password"
              placeholder="Enter your password"
              autocomplete="current-password"
            />
          </div>
        </div>

        <!-- Error -->
        @if (errorMessage) {
          <div class="alert alert-danger py-2 mb-3">
            <i class="bi bi-exclamation-triangle me-1"></i>{{ errorMessage }}
          </div>
        }

        <!-- Validation -->
        @if (validate()) {
          <div class="text-danger fs-8 mb-2">
            <i class="bi bi-info-circle me-1"></i>Please fill in all required fields.
          </div>
        }

        <!-- Submit -->
        <button
          type="submit"
          class="btn btn-primary w-100 erp-login-btn"
          [disabled]="loginForm.invalid"
        >
          Sign In &nbsp;<i class="bi bi-arrow-right-short"></i>
        </button>

      </form>
    </div>
  </div>

</div>
